import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import type { LucideIcon } from 'lucide-react';

interface PesageInputProps extends InputHTMLAttributes<HTMLInputElement> {
  icon?: LucideIcon;
  label?: string;
  error?: string;
}

export const PesageInput = forwardRef<HTMLInputElement, PesageInputProps>(
  ({ icon: Icon, label, error, className = '', ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm text-pesage-secondary mb-1.5">
            {label}
          </label>
        )}
        <div className="relative">
          {Icon && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-pesage-muted">
              <Icon className="w-4 h-4" />
            </div>
          )}
          <input
            ref={ref}
            className={`h-10 w-full rounded-md border border-pesage-border bg-pesage-bg px-3 text-sm text-pesage-primary placeholder-pesage-muted transition-colors focus:border-pesage-green focus:ring-1 focus:ring-pesage-green ${
              Icon ? 'pl-9' : 'pl-3'
            } ${error ? 'border-pesage-red focus:ring-pesage-red focus:border-pesage-red' : ''} ${className}`}
            {...props}
          />
        </div>
        {error && <p className="text-pesage-red text-xs mt-1">{error}</p>}
      </div>
    );
  }
);

PesageInput.displayName = 'PesageInput';
